import * as types from "../constants/ActionTypes";

const initState = {
    scrollPlanTable: false,
    count: 0,
}

const showPlanDasboard = (state = initState, action) => {
    switch (action.type) {
        case types.FECTH_PLAN_TABLE:
            state.scrollPlanTable = action.status;
            state.count += 1;
            return { ...state };
        default:
            return { ...state };
    }
}

export default showPlanDasboard;